import {
  getBidBakeryArtworkNFTContract,
  getBidOneInchBakeNFTContract,
  getBidSeascapeNftContract,
  getBidBakeryArtwork3NFTContract,
  getBidBakeryArtwork2NFTContract,
  getBidBakerySoccerContract,
  getBidTokocryptoNftContract,
  getBidDigitalArtworkNFTContract,
  getBidSfpNFTContract,
  getBidDoggyNFTContract,
  getBidLoveNFTContract,
  getBidYooshiNFTContract,
  getBidDishNFTContract,
  getBidPetEggNFTContract,
  getBidWeaponNFTContract,
  getBidBinanceNftContract,
  getBidPetNftContract,
  getBidCarNFTContract,
  getBidRacaNFTContract,
  getBidBondlyNFTContract,
  getBidBscBakeNFTContract,
  getBidBarkingNFTContract,
} from '../sushi/utils'

import { MARKETTYPE } from '../constants/bakery/nft'

export function userBidNFTContract(sushi: any, type?: string) {
  let contract = getBidDishNFTContract(sushi)
  switch (type) {
    case MARKETTYPE.DISH:
      contract = getBidDishNFTContract(sushi)
      break
    case MARKETTYPE.EGGNFT:
      contract = getBidPetEggNFTContract(sushi)
      break
    case MARKETTYPE.WEAPONNFT:
      contract = getBidWeaponNFTContract(sushi)
      break
    case MARKETTYPE.BINANCENFT:
      contract = getBidBinanceNftContract(sushi)
      break
    case MARKETTYPE.PETNFT:
      contract = getBidPetNftContract(sushi)
      break
    case MARKETTYPE.BAKERYARTWORK:
      contract = getBidBakeryArtworkNFTContract(sushi)
      break
    case MARKETTYPE.ONEINCH:
      contract = getBidOneInchBakeNFTContract(sushi)
      break
    case MARKETTYPE.SEASCAPE:
      contract = getBidSeascapeNftContract(sushi)
      break
    case MARKETTYPE.MEME:
      contract = getBidBakeryArtwork3NFTContract(sushi)
      break
    case MARKETTYPE.MUSKDOGE:
      contract = getBidBakeryArtwork2NFTContract(sushi)
      break
    case MARKETTYPE.BAKERYSOCCER:
      contract = getBidBakerySoccerContract(sushi)
      break
    case MARKETTYPE.TKONFT:
      contract = getBidTokocryptoNftContract(sushi)
      break
    case MARKETTYPE.BTCARTWORK:
      contract = getBidDigitalArtworkNFTContract(sushi)
      break
    case MARKETTYPE.CARNFT:
      contract = getBidCarNFTContract(sushi)
      break
    case MARKETTYPE.SFPARTWORK:
      contract = getBidSfpNFTContract(sushi)
      break
    case MARKETTYPE.DOGGYNFT:
      contract = getBidDoggyNFTContract(sushi)
      break
    case MARKETTYPE.LOVE:
      contract = getBidLoveNFTContract(sushi)
      break
    case MARKETTYPE.YOOSHINFT:
      contract = getBidYooshiNFTContract(sushi)
      break
    case MARKETTYPE.RACANFT:
      contract = getBidRacaNFTContract(sushi)
      break
    case MARKETTYPE.BONDLYNFT:
      contract = getBidBondlyNFTContract(sushi)
      break
    case MARKETTYPE.BAKERYBSCARTWORK:
      contract = getBidBscBakeNFTContract(sushi)
      break
    case MARKETTYPE.BARKNFT:
      contract = getBidBarkingNFTContract(sushi)
      break
  }
  return contract
}
